import React from 'react';
import { useTranslation } from 'react-i18next';

import { JBSection } from '@bjb-gcrm/gcrm-frontend-components';
import { Employee } from 'types/Partner';
import { BrVersionDto } from 'views/RevisionHistory/Br/BrRevisionDtos';
import { BrRevisionHistoryDetailTable } from 'views/RevisionHistory/Br/BrRevisionHistoryDetailTable';
import { format } from 'date-fns';

interface BrRevisionHistoryRowProps {
  techId: string;
  brVersionDtos: BrVersionDto[];
  version: number;
  employees: Employee[];
}

const NON_BREAKING_SPACE = '\u00A0';

export function BrRevisionHistoryRow({ version, techId, brVersionDtos, employees }: BrRevisionHistoryRowProps) {
  const { t } = useTranslation();
  const index = brVersionDtos.findIndex((status) => status.version === version);
  const history = brVersionDtos[index];
  const employee = employees.find((employee) => employee.userId === history.modifiedBy)?.fullName ?? history.modifiedBy;
  const modifiedDate = format(new Date(history.modifiedTimestamp), 'dd.MM.yyyy HH:mm');
  const isDraft = history.brStatus === 'DRAFT';
  const title = isDraft
    ? t('revisionHistory.table.unsubmittedChanges')
    : `${modifiedDate}${NON_BREAKING_SPACE.repeat(4)}${t('revisionHistory.table.submittedBy')} ${employee}`;

  return (
    <JBSection
      title={title}
      customId={'change-section-version-' + version}
      useDivider={true}
      narrowMargins={true}
      defaultExpanded={false}
      infoText={isDraft ? t('revisionHistory.table.unsubmittedChangesInfo') : undefined}
      titleTypographyVariant="h6"
    >
      <BrRevisionHistoryDetailTable techId={techId} index={index} brVersionDtos={brVersionDtos} />
    </JBSection>
  );
}
